// B"H
import { useEffect } from "react";

import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Routes from "./routes";
import { logoutFirebase } from "./auth/operations";

const APP_VERSION = "2025-11-12";

function App() {
  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      setTimeout(() => {
        const el = document.querySelector(hash);
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
      }, 300);
    }
  }, []);

  useEffect(() => {
    const storedVersion = localStorage.getItem("app_version");
  
    if (!storedVersion || storedVersion !== APP_VERSION) {
      localStorage.setItem("app_version", APP_VERSION);
      sessionStorage.clear();
      logoutFirebase().finally(() => {
        window.location.reload();
      });
    } else {
      localStorage.setItem("app_version", APP_VERSION);
    }
  }, []);  


  return (
    <BrowserRouter>
      <Routes />
      <ToastContainer position="bottom-right" autoClose={4000} hideProgressBar />
    </BrowserRouter>
  );
}

export default App;
